.clearButton {
	font-size: 12px;
}
